import { render, staticRenderFns } from "./DialogModifyI18n.vue?vue&type=template&id=895d9790&scoped=true&"
import script from "./DialogModifyI18n.vue?vue&type=script&lang=ts&"
export * from "./DialogModifyI18n.vue?vue&type=script&lang=ts&"
import style0 from "./DialogModifyI18n.vue?vue&type=style&index=0&id=895d9790&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895d9790",
  null
  
)

export default component.exports